if (!customElements.get('wishlist-button')) {
  class WishlistButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.gg-wishlist-button');
      
      this.baseUrl = window.theme?.auth?.wishlistBaseUrl || 'https://app.sportsfuel.co.nz/api/wishlist';
      this.wishlistId = null;
      this.wishlistProductIds = [];
      this.init();
    }

    async init() {
      await this.setWishlistId();
      await this.getWishlistProductIds();
      this.bindEvents();
    }

    async setWishlistId() {
      // Check if customer is logged in
      const customerId = window.Shopify?.customer?.id;
      if (customerId) {
        this.wishlistId = customerId;
        return;
      }

      // Check for __sf_id cookie
      const cookies = document.cookie.split(';');
      const sfIdCookie = cookies.find(cookie => cookie.trim().startsWith('__sf_id='));
      
      if (sfIdCookie) {
        try {
          const encodedId = sfIdCookie.split('=')[1];
          this.wishlistId = atob(encodedId);
        } catch (error) {
          console.error('Error decoding wishlist ID:', error);
        }
      }
    }

    async getWishlistProductIds() {
      if (!this.wishlistId) return;

      try {
        const response = await fetch(`${this.baseUrl}/${this.wishlistId}`);

        if (response.status === 404) { 
          this.wishlistProductIds = null;
          this.style.display = "block";
          return;
        }

        const data = await response.json();

        this.wishlistProductIds = data?.products ? Object.keys(data.products) : [];
        this.style.display = "block";
        this.dataset.saved = this.wishlistProductIds.includes(this.dataset.productId);
      } catch (error) {
        console.error('Error getting wishlist product IDs:', error);
      }
    }

    toggleSaved = async () => {
      this.button.classList.add('is-loading');
      
      if (!this.wishlistProductIds) {
        await this.createWishlist();
      } else if (this.dataset.saved === "true") {
        await this.removeFromWishlist();
      } else {
        await this.addToWishlist();
      }

      this.button.classList.remove('is-loading');
    }

    async addToWishlist() {
      try {
        const response = await fetch(`${this.baseUrl}/${this.wishlistId}/${this.dataset.productId}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            addedAt: Number(new Date())
          })
        });

        if (!response.ok) {
          throw new Error('Failed to add product to wishlist');
        }

        this.dataset.saved = true;
        this.wishlistProductIds = [...this.wishlistProductIds, this.dataset.productId];
      } catch (error) {
        console.error('Error adding product to wishlist:', error);
      }
    }

    async removeFromWishlist() {
      try {
        const response = await fetch(`${this.baseUrl}/${this.wishlistId}/${this.dataset.productId}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error('Failed to remove product from wishlist');
        }

        this.dataset.saved = false;
        this.wishlistProductIds = this.wishlistProductIds.filter(id => id !== this.dataset.productId);
      } catch (error) {
        console.error('Error removing product from wishlist:', error);
      }
    }

    async createWishlist() {
      const response = await fetch(`${this.baseUrl}/${this.wishlistId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          product: {
            id: this.dataset.productId,
            addedAt: Number(new Date())
          }
        })
      });

      if (!response.ok) {
        throw new Error('Failed to create wishlist');
      }
      
      this.wishlistProductIds = [this.dataset.productId];
      this.dataset.saved = true;
    }

    bindEvents() {
      this.button.addEventListener('click', this.toggleSaved);
    }
  }

  customElements.define('wishlist-button', WishlistButton);
}